/**
 * SmartLayout — route wrapper that serves the correct shell based on user role.
 *
 * - caja_user  → CajaLayout (clean top-nav only, "Estrategia en una Caja" brand)
 * - everyone else → standard NVC Layout (sidebar + header)
 *
 * Usage in App.jsx:
 *   <SmartLayout><PhasePage /></SmartLayout>
 */
import { useAuth } from '../../hooks/useAuth'
import Layout     from './Layout'
import CajaLayout from './CajaLayout'

export default function SmartLayout({ children }) {
  const { isCaja } = useAuth()
  if (isCaja) return <CajaLayout>{children}</CajaLayout>
  return <Layout>{children}</Layout>
}
